import { CheckIcon, WarningIcon } from "@chakra-ui/icons";
import { Button, Flex, HStack, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Input } from "@components/form/Input";
import useStorage from "@utils/UseStorage";
import { isInValidEmail } from "@utils/utils";
import { apiPost } from "@api/client";

const ResetPasswordPage = () => {
	const [email, setEmail] = useState("");
	const [resetStatus, setResetStatus] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const { clear } = useStorage();
	const queryClient = useQueryClient();

	useEffect(() => {
		clear();
		queryClient.clear();
	}, []);

	const handleSubmit = async () => {
		if (!email) {
			setResetStatus("error");
			setErrorMessage("E-post krävs.");
			return;
		}
		if (isInValidEmail(email)) {
			setResetStatus("error");
			setErrorMessage("Ange en giltig e-postadress");
			return;
		}
		setIsLoading(true);
		try {
			await apiPost("/reset-password", {
				username: email,
			});
			setResetStatus("success");
		} catch (error: any) {
			console.log("Failed to send password reset request", error);
			if (error?.response?.status === 404) {
				setResetStatus("error");
				setErrorMessage("Användaren hittades inte för den angivna e-postadressen, kontrollera igen");
			} else {
				setResetStatus("error");
				setErrorMessage("En begäran om lösenordsåterställning kunde inte skickas. Vänligen försök igen senare.");
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Flex
			flexDir={"column"}
			bg="brand.500"
			maxW={{ base: "100%", md: "500px" }}
			p="10"
			borderRadius={6}
			margin={{ base: "0", md: "10vh auto" }}
		>
			<img src="/bilda-logo.svg" alt="BILDA Personal" width="170" />

			<Text my="5" color={"white"}>
				Vänligen ange din e-postadress för att skicka länken för återställning av lösenord
			</Text>
			<Input
				onChangeText={(val) => setEmail(val)}
				onFocus={() => setResetStatus("")}
				type="email"
				value={email}
				placeholder="namn@exempel.se"
				label="E-post"
				onDark
				className="row"
			/>
			{resetStatus === "success" && (
				<HStack spacing="2">
					<CheckIcon color="white" />
					<Text color="white" m="0" fontStyle={"italic"} fontSize={"xs"} lineHeight={"shorter"}>
						Begäran om återställning av lösenord har skickats, kolla din e-postinkorg för vidare instruktioner.
					</Text>
				</HStack>
			)}
			{resetStatus === "error" && (
				<HStack>
					<WarningIcon color="white" />
					<Text color="red.100">{errorMessage}</Text>
				</HStack>
			)}
			<Button
				bg="bildaBlack"
				color="white"
				_hover={{ bg: "black" }}
				my="5"
				onClick={handleSubmit}
				disabled={isLoading}
				isLoading={isLoading}
				borderRadius={"50"}
			>
				Återställ lösenord
			</Button>
		</Flex>
	);
};

export default ResetPasswordPage;
